import { MAX_TIMER_MS } from "./sleep-constants";

/** A wait a timer can actually hold: longer means "as long as it can". */
export function timerDelayMs(seconds: number): number {
  return Math.min(Math.max(0, seconds) * 1_000, MAX_TIMER_MS);
}
